import React from 'react';

const RIVER_IMG = {
  '1': null,
  '2': 'milk',
  '3': 'milk-poplar',
  '4': 'yellow-garrison',
  '5': 'poplar',
  '7': 'yellow',
  '8': 'peck-milk',
  '9': 'poplar-yellow',
  '10': 'niobrara-gavins',
  '11': 'randal-niobrara',
  '12': 'niobrara',
  '13': 'cannon',
  '14': 'heart',
  '15': 'knife',
  '16': 'cannon-oahe',
  '17': 'garrison-knife',
  '18': 'heart-cannon',
  '19': 'knife-heart',
}

function HoverMap(props){
  if(!props.river_id){
    return null
  }

  if(!RIVER_IMG[props.river_id]){
    return null
  }
  return (
    <div>
      <div className='hover-map' style={{width: '600px', height: '430px'}}>
        <img 
          src={`../../images/rivers/${RIVER_IMG[props.river_id]}.png`} 
          alt="River Section Preview"
          width="100%"
        />
      </div>
      <p style={{fontWeight: 'bold', textAlign: 'center'}}>{props.river}</p>
    </div>
  )
}

export default HoverMap;


// WEBPACK FOOTER //
// ./src/components/HoverMap.js